import React from 'react';
import { Slider } from '@/components/ui/slider';
import { ZoomIn } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

interface CalendarZoomSliderProps {
  value: number;
  onChange: (value: number) => void;
}

const CalendarZoomSlider: React.FC<CalendarZoomSliderProps> = ({ value, onChange }) => {
  const { t } = useLanguage();
  
  const handleSliderChange = (values: number[]) => {
    console.log('Calendar zoom changed:', values[0]);
    onChange(values[0]);
  };

  return (
    <div className="flex items-center gap-3 p-3 bg-card border rounded-lg">
      <ZoomIn className="h-4 w-4 text-muted-foreground flex-shrink-0" />
      <div className="flex-1 space-y-2">
        <div className="flex items-center justify-between">
          <span className="text-sm font-medium">{t('calendarSize') || 'Calendar Size'}</span>
          <span className="text-xs text-muted-foreground">{Math.round(value * 100)}%</span>
        </div>
        <Slider
          value={[value]}
          onValueChange={handleSliderChange}
          min={0.5}
          max={1.5}
          step={0.1}
          className="w-full"
        />
        <div className="flex justify-between text-xs text-muted-foreground">
          <span>{t('small') || 'Small'}</span>
          <span>{t('large') || 'Large'}</span>
        </div>
      </div>
    </div>
  );
};

export default CalendarZoomSlider;